<template>
  <div>
    <div class="app-container">
      <el-row :gutter="20">
        <!--      <el-col :sm="4">-->
        <!--        <el-card class="box-card">-->
        <!--          <div class="value">{{ data.total_channel_money || 0 }}</div>-->
        <!--          <div class="subtitle">渠道结算价</div>-->
        <!--        </el-card>-->
        <!--      </el-col>-->
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value">{{ data.total_actual_channel_money || 0 }}</div>
            <div class="subtitle">合作商实际账期金额</div>
          </el-card>
        </el-col>
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value">{{ data.total_quota_value || 0 }}</div>
            <div class="subtitle">已扣额度的统计</div>
          </el-card>
        </el-col>
        <!--      <el-col :sm="4">-->
        <!--        <el-card class="box-card">-->
        <!--          <div class="value">{{ data.total_rate || 0 }}</div>-->
        <!--          <div class="subtitle">锦江订单支付总价</div>-->
        <!--        </el-card>-->
        <!--      </el-col>-->
        <el-col :sm="5">
          <el-card class="box-card">
            <div class="value">{{ data.actual_channel_money || 0 }}</div>
            <div class="subtitle">供应商实际账期金额</div>
          </el-card>
        </el-col>
      </el-row>
      <div class="filter-container">
        <el-select
          class="filter-item"
          v-model="listQuery.app_client_id"
          placeholder="选择客户端"
          style="width: 160px"
          clearable
          filterable
          remote
          reserve-keyword
          :remote-method="fetchClientNames"
          :loading="loadingClients"
          @visible-change="handleClientSelectVisible"
        >
          <el-option
            v-for="item in clientNameOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-input
          class="filter-item"
          v-model="listQuery.hotel_name"
          placeholder="酒店名称"
          style="width: 220px"
          clearable
        />

        <el-input
          class="filter-item"
          v-model="listQuery.order_keyword"
          placeholder="全部订单号"
          style="width: 220px"
          clearable
        />
        <el-input
          class="filter-item"
          v-model="listQuery.order_id"
          placeholder="订单号"
          style="width: 220px"
          clearable
        />
        <el-input
          class="filter-item"
          v-model="listQuery.order_confirm_no"
          placeholder="确认号"
          style="width: 220px"
          clearable
        />
        <el-select
          class="filter-item"
          v-model="listQuery.order_target_type"
          placeholder="供应商类型"
          style="width: 160px"
          clearable
        >
          <el-option
            v-for="item in targetTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>

        <el-input
          class="filter-item"
          v-model="listQuery.order_code"
          placeholder="供应商订单编号"
          style="width: 220px"
          clearable
        />

        <el-select
          class="filter-item"
          v-model="listQuery.order_state_arr"
          placeholder="供应商订单状态"
          style="width: 160px"
          multiple
          clearable
        >
          <el-option label="预订成功" :value="1" />
          <el-option label="已取消" :value="2" />
          <el-option label="预订未到" :value="3" />
          <el-option label="已入住" :value="4" />
          <el-option label="已完成" :value="5" />
        </el-select>

        <el-input
          class="filter-item"
          v-model="listQuery.system_order_no"
          placeholder="系统订单号"
          style="width: 220px"
          clearable
        />

        <el-select
          class="filter-item"
          v-model="listQuery.system_order_status_arr"
          placeholder="系统订单状态"
          multiple
          style="width: 160px"
          clearable
        >
          <el-option label="下单待处理" :value="100" />
          <el-option label="下单成功" :value="101" />
          <el-option label="下单失败" :value="102" />
          <el-option label="下单确认中" :value="103" />
          <el-option label="取消订单成功" :value="201" />
          <el-option label="取消订单失败" :value="202" />
          <el-option label="取消订单中" :value="203" />
        </el-select>
        <el-select
          class="filter-item"
          v-model="listQuery.system_order_cancel_status_arr"
          placeholder="系统订单取消状态"
          multiple
          style="width: 160px"
          clearable
        >
          <el-option label="未取消" :value="0" />
          <el-option label="已取消" :value="1" />
          <el-option label="取消订单失败" :value="2" />
        </el-select>
        <el-select
          class="filter-item"
          v-model="listQuery.pay_state_arr"
          placeholder="供应商支付状态"
          multiple
          style="width: 160px"
          clearable
        >
          <el-option label="未付款" :value="0" />
          <el-option label="已付款" :value="1" />
          <el-option label="退款处理中" :value="2" />
          <el-option label="已退款" :value="3" />
        </el-select>
        <el-select
          class="filter-item"
          v-model="listQuery.profit_status"
          placeholder="盈亏状态"
          style="width: 160px"
          clearable
        >
          <el-option label="亏损" :value="0" />
          <el-option label="盈利" :value="1" />
        </el-select>
        <el-select
          class="filter-item"
          v-model="listQuery.quota_status"
          placeholder="额度状态"
          style="width: 160px"
          clearable
        >
          <el-option label="已退额度" :value="-1" />
          <el-option label="未付额度" :value="0" />
          <el-option label="已付额度" :value="1" />
          <el-option label="部分回退额度" :value="2" />
        </el-select>
        <el-select
          class="filter-item"
          v-model="listQuery.manual_override_status"
          placeholder="管理员手动修改状态"
          style="width: 180px"
          clearable
        >
          <el-option label="未手动修改" :value="0" />
          <el-option label="已手动修改" :value="1" />
          <el-option label="生成台账不可更新" :value="2" />
        </el-select>
        <el-input
          class="filter-item"
          v-model="listQuery.link_man"
          placeholder="预定人名称"
          style="width: 220px"
          clearable
        />
        <el-input
          class="filter-item"
          v-model="listQuery.link_phone"
          placeholder="手机号"
          style="width: 220px"
          clearable
        />
        <div>
          入住时间:
          <el-date-picker
            class="filter-item"
            v-model="dateArr"
            type="daterange"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
          离店时间:
          <el-date-picker
            class="filter-item"
            v-model="dateArr1"
            type="daterange"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
          实际离店时间:
          <el-date-picker
            class="filter-item"
            v-model="dateArr3"
            type="daterange"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
          下单时间:
          <el-date-picker
            class="filter-item"
            v-model="dateArr2"
            type="daterange"
            :default-time="['00:00:00', '23:59:59']"
            align="right"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
          <el-button class="filter-item" type="primary" @click="handleFilter"
            >搜索</el-button
          >
          <download-excel
            class="filter-item"
            :fields="json_fields"
            :fetch="handleExport"
            type="xls"
            name="订单列表.xls"
            worksheet="订单列表"
          >
            <!--      :before-generate="startPost"
            :before-finish="endPost"                :header="header"-->
            <el-button type="success" :loading="exportLoading">
              导出订单列表
            </el-button>
          </download-excel>
        </div>
      </div>

      <el-table
        v-loading="listLoading"
        :data="list"
        element-loading-text="Loading"
        border
        fit
        highlight-current-row
        :row-class-name="errorRow"
        :max-height="tableMaxHeight"
      >
        <el-table-column label="房源供应商" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="getTargetTagType(scope.row.target_type)">{{
              scope.row.target_type_name
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="系统订单号" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.system_order_no }}
          </template>
        </el-table-column>
        <el-table-column label="订单号" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.order_id }}
          </template>
        </el-table-column>
        <el-table-column label="供应商订单编号" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.order_code }}
          </template>
        </el-table-column>
        <el-table-column label="确认号" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.order_confirm_no || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="客户端名称" min-width="130" align="center">
          <template slot-scope="scope">
            {{ scope.row.app_client ? scope.row.app_client.name : '-' }}
          </template>
        </el-table-column>
        <!--      <el-table-column label="自我游订单状态" min-width="120" align="center">-->
        <!--        <template slot-scope="scope">-->
        <!--          <el-tag type="primary" v-if="scope.row.state === '0'">新订单</el-tag>-->
        <!--          <el-tag type="warning" v-else-if="scope.row.state === '1'">已确认</el-tag>-->
        <!--          <el-tag type="success" v-else-if="scope.row.state === '2'">已成功</el-tag>-->
        <!--          <el-tag type="danger" v-else-if="scope.row.state === '3'">已取消</el-tag>-->
        <!--          <el-tag type="success" v-else-if="scope.row.state === '4'">已完成</el-tag>-->
        <!--        </template>-->
        <!--      </el-table-column>-->

        <el-table-column label="用户下单金额" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.channel_money }}
          </template>
        </el-table-column>
        <el-table-column
          label="合作商实际账期金额"
          min-width="130"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.actual_channel_money || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="已扣额度" min-width="140" align="center">
          <template slot-scope="scope">
            {{ scope.row.quota_value || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="合作商加价比率" min-width="120" align="center">
          <template slot-scope="scope">
            {{
              scope.row.channel_price_rate != null
                ? (scope.row.channel_price_rate * 100).toFixed(2) + '%'
                : '-'
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="供应商实际账期金额"
          min-width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.actual_total_rate || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.link_man }}
          </template>
        </el-table-column>

        <el-table-column label="联系人手机" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.link_phone }}
          </template>
        </el-table-column>

        <el-table-column label="入住时间" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.travel_date }}
          </template>
        </el-table-column>

        <el-table-column label="离店时间" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.end_travel_date }}
          </template>
        </el-table-column>
        <el-table-column label="实际离店时间" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.actual_end_travel_date }}
          </template>
        </el-table-column>

        <el-table-column label="酒店名称" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.hotel ? scope.row.hotel.inn_name : '' }}
          </template>
        </el-table-column>
        <el-table-column label="酒店电话" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.hotel ? scope.row.hotel.inn_phone : '' }}
          </template>
        </el-table-column>
        <el-table-column label="酒店地址" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.hotel ? scope.row.hotel.address : '' }}
          </template>
        </el-table-column>

        <el-table-column label="售卖房型名称" min-width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.room_type ? scope.row.room_type.room_type_name : '' }}
          </template>
        </el-table-column>

        <el-table-column label="房间间数" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.room_num }}
          </template>
        </el-table-column>

        <!--      <el-table-column label="锦江订单支付总价" min-width="140" align="center">-->
        <!--        <template slot-scope="scope">-->
        <!--          {{ scope.row.total_rate }}-->
        <!--        </template>-->
        <!--      </el-table-column>-->

        <el-table-column label="下单到店时间" min-width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.last_arr_time }}
          </template>
        </el-table-column>

        <el-table-column label="供应商订单状态" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag type="primary" v-if="scope.row.order_state === 1"
              >预订成功</el-tag
            >
            <el-tag type="danger" v-else-if="scope.row.order_state === 2"
              >已取消</el-tag
            >
            <el-tag type="warning" v-else-if="scope.row.order_state === 3"
              >预订未到</el-tag
            >
            <el-tag type="warning" v-else-if="scope.row.order_state === 4"
              >已入住</el-tag
            >
            <el-tag type="success" v-else-if="scope.row.order_state === 5"
              >已完成</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column label="供应商支付状态" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.pay_state === 0">未付款</el-tag>
            <el-tag type="success" v-else-if="scope.row.pay_state === 1"
              >已付款</el-tag
            >
            <el-tag type="warning" v-else-if="scope.row.pay_state === 2"
              >退款处理中</el-tag
            >
            <el-tag type="danger" v-else-if="scope.row.pay_state === 3"
              >已退款</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column label="系统订单状态" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.system_order_status === 100"
              >下单待处理</el-tag
            >
            <el-tag
              type="success"
              v-else-if="scope.row.system_order_status === 101"
              >下单成功</el-tag
            >
            <el-tag
              type="danger"
              v-else-if="scope.row.system_order_status === 102"
              >下单失败</el-tag
            >
            <el-tag
              type="warning"
              v-else-if="scope.row.system_order_status === 103"
              >下单确认中</el-tag
            >
            <el-tag
              type="success"
              v-else-if="scope.row.system_order_status === 201"
              >取消订单成功</el-tag
            >
            <el-tag
              type="danger"
              v-else-if="scope.row.system_order_status === 202"
              >取消订单失败</el-tag
            >
            <el-tag
              type="danger"
              v-else-if="scope.row.system_order_status === 203"
              >取消订单中</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="系统订单取消状态"
          min-width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              type="info"
              v-if="scope.row.system_order_cancel_status === 0"
              >未取消</el-tag
            >
            <el-tag
              type="success"
              v-else-if="scope.row.system_order_cancel_status === 1"
              >已取消</el-tag
            >
            <el-tag
              type="danger"
              v-else-if="scope.row.system_order_cancel_status === 2"
              >取消订单失败</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="操作处理失败信息"
          min-width="140"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.handle_error_message || '-' }}
          </template>
        </el-table-column>

        <el-table-column label="额度状态" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.quota_status === 0"
              >未付额度</el-tag
            >
            <el-tag type="success" v-else-if="scope.row.quota_status === 1"
              >已付额度
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.quota_status === -1"
              >已退额度</el-tag
            >
            <el-tag type="warning" v-else-if="scope.row.quota_status === 2"
              >部分回退额度</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="管理员手动修改状态"
          min-width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.manual_override_status === 0"
              >未手动修改</el-tag
            >
            <el-tag
              type="success"
              v-else-if="scope.row.manual_override_status === 1"
              >已手动修改</el-tag
            >
            <el-tag
              type="warning"
              v-else-if="scope.row.manual_override_status === 2"
              >生成台账不可更新</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="140" align="center">
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>

        <el-table-column label="创建时间" min-width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.created_at }}
          </template>
        </el-table-column>

        <el-table-column label="下单时间" min-width="160" align="center">
          <template slot-scope="scope">
            {{ scope.row.order_date }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="260"
          align="center"
          fixed="right"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              v-if="$canEdit"
              type="success"
              size="mini"
              @click="handleModifyLastArrTime(scope.row)"
              :disabled="scope.row.system_order_status !== 102"
              >修改到店时间
            </el-button>
            <div style="margin-top: 5px">
              <el-button
                type="primary"
                size="mini"
                @click="handleOrderDetail(scope.row)"
              >
                订单详情
              </el-button>
              <el-button
                type="primary"
                size="mini"
                @click="handleOrderInfo(scope.row)"
              >
                下单信息
              </el-button>

              <!--            <el-button type="warning" size="mini" @click="handleReOrder(scope.row)"-->
              <!--                       :disabled="!(scope.row.system_order_status === 102)">重新下单-->
              <!--            </el-button>-->
            </div>
            <div style="margin-top: 5px">
              <el-button
                type="primary"
                size="mini"
                @click="handleOrderChangeLog(scope.row)"
              >
                订单修改记录
              </el-button>
            </div>
            <div style="margin-top: 5px" v-if="$canEdit">
              <el-button
                type="danger"
                size="mini"
                @click="handleCancelOrder(scope.row)"
                :disabled="
                  !(
                    scope.row.order_state === 1 ||
                    scope.row.system_order_status === 103
                  )
                "
                >取消订单
              </el-button>

              <el-button
                type="primary"
                size="mini"
                @click="handleComplete(scope.row)"
                :disabled="handleCompleteStatus(scope.row)"
                >处理完成
              </el-button>
            </div>
            <div style="margin-top: 5px" v-if="$canEdit">
              <el-button
                type="success"
                size="mini"
                @click="handleChangeSystemOrderStatus(scope.row)"
                >修改系统订单状态
              </el-button>
            </div>
            <div style="margin-top: 5px" v-if="$canEdit">
              <el-button
                type="success"
                size="mini"
                @click="handleChangeOrderState(scope.row)"
                >修改供应商订单状态
              </el-button>

              <el-button
                type="primary"
                size="mini"
                @click="syncOrder(scope.row)"
                >同步订单</el-button
              >
            </div>
            <div style="margin-top: 5px" v-if="$canEdit">
              <el-button
                type="success"
                size="mini"
                @click="handleStoreRemark(scope.row)"
                >修改备注
              </el-button>
              <el-button
                type="warning"
                size="mini"
                @click="handleStoreQuota(scope.row)"
                v-if="scope.row.quota_status !== 0"
                >修改已扣额度
              </el-button>
            </div>
            <div style="margin-top: 5px" v-if="$canEdit">
              <el-button
                type="success"
                size="mini"
                @click="handleStoreActualEndTravelDate(scope.row)"
                >修改实际离店时间
              </el-button>
            </div>
            <div style="margin-top: 5px" v-if="$canEdit">
              <el-button
                type="success"
                size="mini"
                @click="handleStoreActualTotalRate(scope.row)"
                >修改供应商实际账期金额
              </el-button>
            </div>
            <el-button
              style="margin-top: 5px"
              size="mini"
              type="primary"
              @click="handleShowNightPrices(scope.row)"
              >每晚价格</el-button
            >
            <el-button
              v-if="$canEdit"
              style="margin-top: 5px"
              size="mini"
              type="warning"
              @click="handleChangeManualOverrideStatus(scope.row)"
              >手动修改状态</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          :current-page="listQuery.page"
          :page-sizes="[5, 10, 20, 30, 50]"
          :page-size="listQuery.limit"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

      <!-- 修改到店时间 -->
      <el-dialog
        title="修改到店时间"
        :visible.sync="dialogVisibleModifyLastArrTime"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="modifyLastArrTimeForm"
          :rules="modifyLastArrTimeRules"
          :model="modifyLastArrTimeForm"
          label-width="150px"
        >
          <el-form-item label="修改到店时间" prop="last_arr_time">
            <el-date-picker
              v-model="modifyLastArrTimeForm.last_arr_time"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleModifyLastArrTime = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveDataModifyLastArrTime"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改到店时间 -->

      <!-- 修改系统订单状态 -->
      <el-dialog
        title="修改系统订单状态"
        :visible.sync="dialogVisibleChangeSystemOrderStatus"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="changeSystemOrderStatusForm"
          :rules="changeSystemOrderStatusRules"
          :model="changeSystemOrderStatusForm"
          label-width="150px"
        >
          <el-form-item label="修改系统订单状态" prop="system_order_status">
            <el-select
              class="filter-item"
              v-model="changeSystemOrderStatusForm.system_order_status"
              placeholder="系统订单状态"
              style="width: 160px"
              clearable
            >
              <el-option label="下单待处理" :value="100" />
              <el-option label="下单成功" :value="101" />
              <el-option label="下单失败" :value="102" />
              <el-option label="下单确认中" :value="103" />
              <el-option label="取消订单成功" :value="201" />
              <el-option label="取消订单失败" :value="202" />
              <el-option label="取消订单中" :value="203" />
            </el-select>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleChangeSystemOrderStatus = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveDataChangeSystemOrderStatus"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改系统订单状态 -->

      <!-- 修改订单备注 -->
      <el-dialog
        title="修改订单备注"
        :visible.sync="dialogVisibleStoreRemark"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="storeRemarkForm"
          :rules="storeRemarkRules"
          :model="storeRemarkForm"
          label-width="150px"
        >
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="storeRemarkForm.remark"
              type="textarea"
              :rows="4"
              placeholder="请输入备注内容"
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleStoreRemark = false">取消</el-button>
          <el-button
            type="primary"
            @click="saveDataStoreRemark"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改订单备注 -->

      <!-- 修改锦江订单状态 -->
      <el-dialog
        title="修改供应商订单状态"
        :visible.sync="dialogVisibleChangeOrderState"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="changeOrderStateForm"
          :rules="changeOrderStateRules"
          :model="changeOrderStateForm"
          label-width="150px"
        >
          <el-form-item label="修改供应商订单状态" prop="system_order_status">
            <el-select
              class="filter-item"
              v-model="changeOrderStateForm.order_state"
              placeholder="供应商订单状态"
              style="width: 160px"
              clearable
            >
              <el-option label="预订成功" :value="1" />
              <el-option label="已取消" :value="2" />
              <el-option label="预订未到" :value="3" />
              <el-option label="已入住" :value="4" />
              <el-option label="已完成" :value="5" />
            </el-select>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleChangeOrderState = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveDataChangeOrderState"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改锦江订单状态 -->

      <!-- 修改额度 -->
      <el-dialog
        title="修改订单已扣额度"
        :visible.sync="dialogVisibleStoreQuota"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="storeQuotaForm"
          :rules="storeQuotaRules"
          :model="storeQuotaForm"
          label-width="150px"
        >
          <el-form-item label="已扣额度" prop="quota_value">
            <el-input
              v-model="storeQuotaForm.quota_value"
              type="number"
              placeholder="请输入已扣额度"
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleStoreQuota = false">取消</el-button>
          <el-button
            type="primary"
            @click="saveDataStoreQuota"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改额度 -->
      <!-- 修改实际离店时间 -->
      <el-dialog
        title="修改实际离店时间"
        :visible.sync="dialogVisibleStoreActualEndTravelDate"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="storeActualEndTravelDateForm"
          :rules="storeActualEndTravelDateRules"
          :model="storeActualEndTravelDateForm"
          label-width="150px"
        >
          <el-form-item label="实际离店时间" prop="actual_end_travel_date">
            <el-date-picker
              v-model="storeActualEndTravelDateForm.actual_end_travel_date"
              type="datetime"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleStoreActualEndTravelDate = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveDataStoreActualEndTravelDate"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改实际离店时间 -->
      <!-- 修改锦江实际账期金额 -->
      <el-dialog
        title="修改供应商实际账期金额"
        :visible.sync="dialogVisibleStoreActualTotalRate"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="storeActualTotalRateForm"
          :rules="storeActualTotalRateRules"
          :model="storeActualTotalRateForm"
          label-width="150px"
        >
          <el-form-item label="供应商实际账期金额" prop="actual_total_rate">
            <el-input
              v-model="storeActualTotalRateForm.actual_total_rate"
              type="number"
              placeholder="请输入供应商实际账期金额"
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleStoreActualTotalRate = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveDataStoreActualTotalRate"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改实际离店时间 -->

      <!-- 每晚价格 -->
      <el-dialog
        :title="'每晚价格 - 订单号: ' + nightPricesOrderId"
        :visible.sync="dialogVisibleNightPrices"
        :close-on-click-modal="false"
        width="600px"
      >
        <div style="margin-bottom: 10px; padding: 0 10px">
          <span style="font-size: 14px; color: #666"
            >入住人：{{ nightPricesGuestName }}</span
          >
        </div>
        <el-table :data="nightPricesData" border fit size="small">
          <el-table-column label="入住日期" align="center" min-width="180">
            <template slot-scope="scope">
              {{ scope.row.night_date }}
            </template>
          </el-table-column>
          <el-table-column label="售价" align="center" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.sell_price }}
            </template>
          </el-table-column>
          <el-table-column label="成本价" align="center" min-width="120">
            <template slot-scope="scope">
              {{ scope.row.cost_price }}
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <!-- 每晚价格 -->

      <!-- 手动修改状态 -->
      <el-dialog
        title="手动修改状态"
        :visible.sync="dialogVisibleChangeManualOverrideStatus"
        width="60%"
        :close-on-click-modal="false"
      >
        <el-form
          ref="changeManualOverrideStatusForm"
          :rules="changeManualOverrideStatusRules"
          :model="changeManualOverrideStatusForm"
          label-width="150px"
        >
          <el-form-item label="修改状态" prop="manual_override_status">
            <el-select
              v-model="changeManualOverrideStatusForm.manual_override_status"
              placeholder="请选择状态"
              style="width: 160px"
              clearable
            >
              <el-option label="未手动修改" :value="0" />
              <el-option label="已手动修改" :value="1" />
              <el-option label="生成台账不可更新" :value="2" />
            </el-select>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleChangeManualOverrideStatus = false"
            >取消</el-button
          >
          <el-button
            type="primary"
            @click="saveDataChangeManualOverrideStatus"
            :loading="btnLoading"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 手动修改状态 -->

      <!-- 下单信息 -->
      <el-dialog
        title="下单信息"
        :visible.sync="dialogVisibleOrderInfo"
        width="60%"
        :close-on-click-modal="false"
      >
        <div
          style="
            white-space: pre-wrap;
            font-size: 14px;
            line-height: 2;
            padding: 10px;
          "
        >
          {{ orderInfoText }}
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleOrderInfo = false">关闭</el-button>
          <el-button type="primary" @click="copyOrderInfo">复制信息</el-button>
        </div>
      </el-dialog>
      <!-- 下单信息 -->
    </div>

    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisibleOrderDetail"
      :close-on-click-modal="false"
      width="80%"
      top="30px"
      @closed="handleOrderDetailClosed"
    >
      <orderDetailShow
        :orderId="orderDetailId"
        dialogMode
        v-if="dialogVisibleOrderDetail"
      />
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
import moment from 'moment'
import orderDetailShow from './orderDetailShow.vue'
import { getTargetTypeName } from '@/utils/targetType'

export default {
  components: { downloadExcel, orderDetailShow },
  data() {
    return {
      clientNameOptions: [],
      targetTypeOptions: [],
      loadingClients: false,
      clientPage: 1,
      clientKeyword: '',
      clientFinished: false,
      pageSize: 99999999,

      tableMaxHeight: 950,
      list: [],
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        app_client_id: '',
        order_id: '',
        state: '',
        order_code: '',
        order_state: '',
        system_order_no: '',
        system_order_status: '',
        state_arr: [],
        order_state_arr: [],
        system_order_status_arr: [],
        system_order_cancel_status_arr: [],
        pay_state_arr: [],
      },
      data: {
        total_account_money: 0,
        total_channel_money: 0,
      },
      // 修改到店时间
      btnLoading: false,
      dialogVisibleModifyLastArrTime: false,
      modifyLastArrTimeForm: {
        order_id: '',
        last_arr_time: '',
      },
      modifyLastArrTimeRules: {
        last_arr_time: [
          { required: true, message: '到店时间不能为空', trigger: 'change' },
        ],
      },
      dialogVisibleChangeSystemOrderStatus: false,
      changeSystemOrderStatusForm: {
        order_id: '',
        system_order_status: '',
      },
      changeSystemOrderStatusRules: {
        system_order_status: [
          { required: true, message: '系统状态不能为空', trigger: 'change' },
        ],
      },
      dialogVisibleChangeOrderState: false,
      changeOrderStateForm: {
        order_id: '',
        order_state: '',
      },
      changeOrderStateRules: {
        order_state: [
          {
            required: true,
            message: '供应商订单状态不能为空',
            trigger: 'change',
          },
        ],
      },
      dialogVisibleStoreRemark: false,
      storeRemarkForm: {
        order_id: '',
        remark: '',
      },
      storeRemarkRules: {
        remark: [
          { required: true, message: '备注不能为空', trigger: 'change' },
        ],
      },
      dialogVisibleStoreQuota: false,
      storeQuotaForm: {
        order_id: '',
        quota_value: '',
      },
      storeQuotaRules: {
        quota_value: [
          { required: true, message: '已扣额度不能为空', trigger: 'change' },
        ],
      },
      dialogVisibleStoreActualEndTravelDate: false,
      storeActualEndTravelDateForm: {
        order_id: '',
        actual_end_travel_date: '',
      },
      storeActualEndTravelDateRules: {
        actual_end_travel_date: [
          {
            required: true,
            message: '实际离店时间不能为空',
            trigger: 'change',
          },
        ],
      },
      dialogVisibleStoreActualTotalRate: false,
      storeActualTotalRateForm: {
        order_id: '',
        actual_total_rate: '',
      },
      storeActualTotalRateRules: {
        actual_total_rate: [
          {
            required: true,
            message: '供应商实际账期金额不能为空',
            trigger: 'change',
          },
        ],
      },
      dialogVisibleChangeManualOverrideStatus: false,
      changeManualOverrideStatusForm: {
        order_id: '',
        manual_override_status: '',
      },
      changeManualOverrideStatusRules: {
        manual_override_status: [
          { required: true, message: '状态不能为空', trigger: 'change' },
        ],
      },
      dateArr: null,
      dateArr1: null,
      dateArr2: null,
      dateArr3: null,
      exportLoading: false,
      dialogVisibleNightPrices: false,
      nightPricesData: [],
      nightPricesOrderId: '',
      nightPricesGuestName: '',
      dialogVisibleOrderInfo: false,
      orderInfoText: '',
      dialogVisibleOrderDetail: false,
      orderDetailId: '',
      json_fields: {
        房源供应商: {
          field: 'target_type',
          //自定义回调函数
          callback: (value) => {
            const state_remark = getTargetTypeName(value)
            return (
              '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
            )
          },
        },
        订单号: {
          field: 'order_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        // 自我游订单状态: {
        //   field: 'state',
        //   //自定义回调函数
        //   callback: (value) => {
        //     var state_remark;
        //     switch (value) {
        //       case '0':
        //         state_remark = '新订单'
        //         break;
        //       case '1':
        //         state_remark = '已确认'
        //         break;
        //       case '2':
        //         state_remark = '已成功'
        //         break;
        //       case '3':
        //         state_remark = '已取消'
        //         break;
        //       case '4':
        //         state_remark = '已完成'
        //         break;
        //       default:
        //         state_remark = ''
        //         break;
        //     }
        //
        //     return '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
        //   },
        // },
        下单时间: {
          field: 'order_date',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户下单金额: {
          field: 'channel_money',
          //自定义回调函数
          callback: (value) => {
            return value
          },
        },
        合作商实际账期金额: {
          field: 'actual_channel_money',
          //自定义回调函数
          callback: (value) => {
            return value
          },
        },
        合作商加价比率: {
          field: 'channel_price_rate',
          callback: (value) => {
            return value != null ? (value * 100).toFixed(2) + '%' : ''
          },
        },
        联系人姓名: {
          field: 'link_man',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        联系人手机: {
          field: 'link_phone',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        入住时间: {
          field: 'travel_date',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        离店时间: {
          field: 'end_travel_date',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        实际离店时间: {
          field: 'actual_end_travel_date',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        酒店名称: {
          field: 'hotel',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              (value ? value.inn_name : '') +
              '</p>'
            )
          },
        },
        售卖房型名称: {
          field: 'room_type',
          //自定义回调函数
          callback: (value) => {
            return (
              '<p style="mso-number-format:\'\\@\';">' +
              (value ? value.room_type_name : '') +
              '</p>'
            )
          },
        },
        房间间数: {
          field: 'room_num',
          //自定义回调函数
          callback: (value) => {
            return value
          },
        },
        供应商订单编号: {
          field: 'order_code',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        // 锦江订单支付总价: {
        //   field: 'total_rate',
        //   //自定义回调函数
        //   callback: (value) => {
        //     return value
        //   },
        // },
        供应商实际账期金额: {
          field: 'actual_total_rate',
          //自定义回调函数
          callback: (value) => {
            return value
          },
        },
        下单到店时间: {
          field: 'last_arr_time',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        供应商订单状态: {
          field: 'order_state',
          //自定义回调函数
          callback: (value) => {
            var state_remark
            switch (value) {
              case 1:
                state_remark = '预订成功'
                break
              case 2:
                state_remark = '已取消'
                break
              case 3:
                state_remark = '预订未到'
                break
              case 4:
                state_remark = '已入住'
                break
              case 5:
                state_remark = '已完成'
                break
              default:
                state_remark = ''
                break
            }

            return (
              '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
            )
          },
        },
        供应商支付状态: {
          field: 'pay_state',
          //自定义回调函数
          callback: (value) => {
            var state_remark
            switch (value) {
              case 0:
                state_remark = '未付款'
                break
              case 1:
                state_remark = '已付款'
                break
              case 2:
                state_remark = '退款处理中'
                break
              case 3:
                state_remark = '已退款'
                break
              default:
                state_remark = ''
                break
            }

            return (
              '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
            )
          },
        },
        系统订单号: {
          field: 'system_order_no',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        系统订单状态: {
          field: 'system_order_status',
          //自定义回调函数
          callback: (value) => {
            var state_remark
            switch (value) {
              case 100:
                state_remark = '下单待处理'
                break
              case 101:
                state_remark = '下单成功'
                break
              case 102:
                state_remark = '下单失败'
                break
              case 103:
                state_remark = '下单确认中'
                break
              case 201:
                state_remark = '取消订单成功'
                break
              case 202:
                state_remark = '取消订单失败'
                break
              case 203:
                state_remark = '取消订单中'
                break
              default:
                state_remark = ''
                break
            }

            return (
              '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
            )
          },
        },
        系统订单取消状态: {
          field: 'system_order_cancel_status',
          //自定义回调函数
          callback: (value) => {
            var state_remark
            switch (value) {
              case 0:
                state_remark = '未取消'
                break
              case 1:
                state_remark = '已取消'
                break
              case 2:
                state_remark = '取消订单失败'
                break
              default:
                state_remark = ''
                break
            }

            return (
              '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
            )
          },
        },
        操作处理失败信息: {
          field: 'handle_error_message',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },

        已扣额度: {
          field: 'quota_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        额度状态: {
          field: 'quota_status',
          //自定义回调函数
          callback: (value) => {
            var state_remark
            switch (value) {
              case -1:
                state_remark = '已退额度'
                break
              case 0:
                state_remark = '未付额度'
                break
              case 1:
                state_remark = '已付额度'
                break
              case 2:
                state_remark = '部分回退额度'
                break
            }

            return (
              '<p style="mso-number-format:\'\\@\';">' + state_remark + '</p>'
            )
          },
        },
        备注: {
          field: 'remark',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        创建时间: {
          field: 'created_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
    }
  },
  created() {
    if (this.$route.query.settlement_date) {
      this.listQuery.end_travel_date_start_at = moment(
        this.$route.query.settlement_date,
      )
        .startOf('month')
        .format('YYYY-MM-DD')
      this.listQuery.end_travel_date_end_at = moment(
        this.$route.query.settlement_date,
      )
        .endOf('month')
        .format('YYYY-MM-DD')
      this.listQuery.order_state_arr = [Number(this.$route.query.order_state)]
      this.listQuery.system_order_status_arr = [
        Number(this.$route.query.system_order_status),
      ]
      this.dateArr1 = [
        this.listQuery.end_travel_date_start_at,
        this.listQuery.end_travel_date_end_at,
      ]
    }

    // 默认近60天
    this.dateArr2 = [
      moment().subtract(60, 'days').format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD'),
    ]
    this.fetchClientNames('')
    this.fetchTargetTypes()
    this.calcTableMaxHeight()
    window.addEventListener('resize', this.calcTableMaxHeight)
    this.getList()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableMaxHeight)
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0]
        this.listQuery.end_at = newVal[1]
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    dateArr1(newVal, oldVal) {
      if (newVal) {
        this.listQuery.end_travel_date_start_at = newVal[0]
        this.listQuery.end_travel_date_end_at = newVal[1]
      } else {
        this.listQuery.end_travel_date_start_at = ''
        this.listQuery.end_travel_date_end_at = ''
      }
    },
    dateArr2(newVal, oldVal) {
      if (newVal) {
        this.listQuery.order_date_start_at = newVal[0] + ' 00:00:00'
        this.listQuery.order_date_end_at = newVal[1] + ' 23:59:59'
      } else {
        this.listQuery.order_date_start_at = ''
        this.listQuery.order_date_end_at = ''
      }
    },
    dateArr3(newVal, oldVal) {
      if (newVal) {
        this.listQuery.actual_end_travel_date_start_at = newVal[0]
        this.listQuery.actual_end_travel_date_end_at = newVal[1]
      } else {
        this.listQuery.actual_end_travel_date_start_at = ''
        this.listQuery.actual_end_travel_date_end_at = ''
      }
    },
  },
  methods: {
    calcTableMaxHeight() {
      this.tableMaxHeight = Math.min(950, window.innerHeight - 165)
    },
    getTargetTypeName: getTargetTypeName,
    getTargetTagType(targetType) {
      const typeMap = {
        jin_jiang: 'primary',
        long_teng: 'warning',
        sui_chuan: 'success',
      }
      return typeMap[targetType] || 'info'
    },
    fetchClientNames(query) {
      // 每次新搜索或首次加载都重置
      this.clientPage = 1
      this.clientKeyword = query
      this.clientFinished = false
      this.clientNameOptions = []
      this.loadMoreClients()
    },
    fetchTargetTypes() {
      request({
        url: '/api/backend/target-type/list',
        method: 'get',
      }).then((res) => {
        if (res.code === 0 || res.code === 200) {
          this.targetTypeOptions = res.data || []
        }
      })
    },
    loadMoreClients() {
      if (this.clientFinished || this.loadingClients) return

      this.loadingClients = true

      request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: {
          name: this.clientKeyword,
          page: this.clientPage,
          limit: this.pageSize,
        },
      })
        .then((res) => {
          const list = res.data.data || []

          if (list.length < this.pageSize) this.clientFinished = true

          this.clientNameOptions = this.clientNameOptions.concat(
            list.map((item) => ({
              label: item.name, // 客户端名称
              value: item.id, // 也使用名称作为 value
            })),
          )
          if (this.$route.query.app_client_id) {
            this.listQuery.app_client_id = Number(
              this.$route.query.app_client_id,
            )
          }
          this.clientPage++
        })
        .finally(() => {
          this.loadingClients = false
        })
    },
    // 监听下拉框打开，绑定滚动分页
    handleClientSelectVisible(visible) {
      if (!visible) return

      this.$nextTick(() => {
        // 使用 Element UI 的 class：el-scrollbar__wrap
        const dropdown = document.querySelector('.el-scrollbar__wrap')
        if (dropdown && !dropdown.dataset.bound) {
          dropdown.dataset.bound = 'true' // 防止重复绑定

          dropdown.addEventListener('scroll', () => {
            const nearBottom =
              dropdown.scrollTop + dropdown.clientHeight >=
              dropdown.scrollHeight - 10
            if (nearBottom) {
              this.loadMoreClients()
            }
          })
        }
      })
    },
    handleExport() {
      if (this.listQuery.state_arr) {
        this.listQuery.state = this.listQuery.state_arr.join(',')
      }

      if (this.listQuery.order_state_arr) {
        this.listQuery.order_state = this.listQuery.order_state_arr.join(',')
      }

      if (this.listQuery.system_order_status_arr) {
        this.listQuery.system_order_status =
          this.listQuery.system_order_status_arr.join(',')
      }
      if (this.listQuery.system_order_cancel_status_arr) {
        this.listQuery.system_order_cancel_status =
          this.listQuery.system_order_cancel_status_arr.join(',')
      }
      if (this.listQuery.pay_state_arr) {
        this.listQuery.pay_state = this.listQuery.pay_state_arr.join(',')
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      listQuery.limit = 9999999999
      return request({
        url: '/api/backend/order/orderList',
        method: 'get',
        params: listQuery,
      })
        .then((response) => {
          return response.data.items
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    getList() {
      if (this.listQuery.state_arr) {
        this.listQuery.state = this.listQuery.state_arr.join(',')
      }

      if (this.listQuery.order_state_arr) {
        this.listQuery.order_state = this.listQuery.order_state_arr.join(',')
      }

      if (this.listQuery.system_order_status_arr) {
        this.listQuery.system_order_status =
          this.listQuery.system_order_status_arr.join(',')
      }
      if (this.listQuery.system_order_cancel_status_arr) {
        this.listQuery.system_order_cancel_status =
          this.listQuery.system_order_cancel_status_arr.join(',')
      }
      if (this.listQuery.pay_state_arr) {
        this.listQuery.pay_state = this.listQuery.pay_state_arr.join(',')
      }

      this.listLoading = true
      request({
        url: '/api/backend/order/orderList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items || []
        this.total = response.data.total || 0
        this.data = response.data.count || {}
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    errorRow({ row }) {
      if (
        [102, 202].includes(row.system_order_status) &&
        row.error_order_handle_status === 0
      ) {
        return 'error-row'
      }
      return ''
    },
    // 修改到店时间
    handleModifyLastArrTime(row) {
      this.modifyLastArrTimeForm = {
        order_id: row.order_id,
        last_arr_time: '',
      }
      this.dialogVisibleModifyLastArrTime = true
      this.$nextTick(() => {
        this.$refs['modifyLastArrTimeForm'].clearValidate() //清除校验结果
      })
    },
    saveDataModifyLastArrTime() {
      this.$refs['modifyLastArrTimeForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/modifyLastArrTime',
            method: 'post',
            data: this.modifyLastArrTimeForm,
          })
            .then(() => {
              this.dialogVisibleModifyLastArrTime = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 修改系统状态
    handleChangeSystemOrderStatus(row) {
      this.changeSystemOrderStatusForm = {
        order_id: row.order_id,
        system_order_status: row.system_order_status,
      }
      this.dialogVisibleChangeSystemOrderStatus = true
      this.$nextTick(() => {
        this.$refs['changeSystemOrderStatusForm'].clearValidate() //清除校验结果
      })
    },
    saveDataChangeSystemOrderStatus() {
      this.$refs['changeSystemOrderStatusForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/changeSystemOrderStatus',
            method: 'post',
            data: this.changeSystemOrderStatusForm,
          })
            .then(() => {
              this.dialogVisibleChangeSystemOrderStatus = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 修改锦江订单状态
    handleChangeOrderState(row) {
      this.changeOrderStateForm = {
        order_id: row.order_id,
        order_state: row.order_state,
      }
      this.dialogVisibleChangeOrderState = true
      this.$nextTick(() => {
        this.$refs['changeOrderStateForm'].clearValidate() //清除校验结果
      })
    },
    saveDataChangeOrderState() {
      this.$refs['changeOrderStateForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/changeOrderState',
            method: 'post',
            data: this.changeOrderStateForm,
          })
            .then(() => {
              this.dialogVisibleChangeOrderState = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 修改备注
    handleStoreRemark(row) {
      this.storeRemarkForm = {
        order_id: row.order_id,
        remark: row.remark,
      }
      this.dialogVisibleStoreRemark = true
      this.$nextTick(() => {
        this.$refs['storeRemarkForm'].clearValidate() //清除校验结果
      })
    },
    saveDataStoreRemark() {
      this.$refs['storeRemarkForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/storeRemark',
            method: 'post',
            data: this.storeRemarkForm,
          })
            .then(() => {
              this.dialogVisibleStoreRemark = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 修改额度
    handleStoreActualEndTravelDate(row) {
      this.storeActualEndTravelDateForm = {
        order_id: row.order_id,
        actual_end_travel_date: row.actual_end_travel_date,
      }
      this.dialogVisibleStoreActualEndTravelDate = true
      this.$nextTick(() => {
        this.$refs['storeActualEndTravelDateForm'].clearValidate() //清除校验结果
      })
    },
    saveDataStoreActualEndTravelDate() {
      this.$refs['storeActualEndTravelDateForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/changeActualEndTravelDate',
            method: 'post',
            data: this.storeActualEndTravelDateForm,
          })
            .then(() => {
              this.dialogVisibleStoreActualEndTravelDate = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 修改实际离店时间
    handleStoreQuota(row) {
      this.storeQuotaForm = {
        order_id: row.order_id,
        quota_value: row.quota_value,
      }
      this.dialogVisibleStoreQuota = true
      this.$nextTick(() => {
        this.$refs['storeQuotaForm'].clearValidate() //清除校验结果
      })
    },
    saveDataStoreQuota() {
      this.$refs['storeQuotaForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/storeQuota',
            method: 'post',
            data: this.storeQuotaForm,
          })
            .then(() => {
              this.dialogVisibleStoreQuota = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 修改锦江实际账期金额
    handleStoreActualTotalRate(row) {
      this.storeActualTotalRateForm = {
        order_id: row.order_id,
        actual_total_rate: row.actual_total_rate,
      }
      this.dialogVisibleStoreActualTotalRate = true
      this.$nextTick(() => {
        this.$refs['storeActualTotalRateForm'].clearValidate() //清除校验结果
      })
    },
    saveDataStoreActualTotalRate() {
      this.$refs['storeActualTotalRateForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/changeActualTotalRate',
            method: 'post',
            data: this.storeActualTotalRateForm,
          })
            .then(() => {
              this.dialogVisibleStoreActualTotalRate = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 重新下单
    handleReOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/order/reOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 取消订单
    handleCancelOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/order/cancelOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 处理完成
    handleComplete(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/order/handleComplete',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 同步订单
    syncOrder(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/order/syncOrder',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    // 回退额度
    revokeQuota(row) {
      this.$confirm('确认继续该操作', '提示', {
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/order/revokeQuota',
            method: 'post',
            data: {
              order_id: row.order_id,
            },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功',
            })
          })
        })
        .catch(() => {})
    },
    handleCompleteStatus(row) {
      let errorStatus = [102, 202]
      return !(
        errorStatus.includes(row.system_order_status) &&
        row.error_order_handle_status === 0
      )
    },
    // 手动修改状态
    handleChangeManualOverrideStatus(row) {
      this.changeManualOverrideStatusForm = {
        order_id: row.order_id,
        manual_override_status: row.manual_override_status,
      }
      this.dialogVisibleChangeManualOverrideStatus = true
      this.$nextTick(() => {
        this.$refs['changeManualOverrideStatusForm'].clearValidate()
      })
    },
    saveDataChangeManualOverrideStatus() {
      this.$refs['changeManualOverrideStatusForm'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/order/changeManualOverrideStatus',
            method: 'post',
            data: this.changeManualOverrideStatusForm,
          })
            .then(() => {
              this.dialogVisibleChangeManualOverrideStatus = false
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    // 下单信息
    handleOrderInfo(row) {
      const hotelName = row.hotel ? row.hotel.inn_name : ''
      const roomType = row.room_type ? row.room_type.room_type_name : ''
      const productName = row.first_night_room_status
        ? row.first_night_room_status.product_name
        : ''
      const line1 = hotelName + ' ' + roomType + ' ' + productName
      let line2 = ''
      // line2 =
      //   current.format('YYYY-MM-DD') +
      //   '(' +
      //   (row.room_num || 1) +
      //   '间)' +
      //   breakfast
      ;(row.night_prices || []).forEach((element, index) => {
        line2 +=
          (index > 0 ? '\n' : '') +
          moment(element.night_date).format('YYYY-MM-DD') +
          '(' +
          (row.room_num || 1) +
          '间)' +
          (element.breakfast_text || '')
      })
      const line3 =
        '下单：' +
        (row.order_date || '-') +
        '  入住日期:' +
        (row.travel_date || '-')
      const line4 =
        '入住人：' +
        (row.link_man || '-') +
        ' (' +
        (row.link_phone || '-') +
        ')'
      const line5 = '订单号： ' + (row.order_code || '-')
      // const line55 = '供应商订单号：' + (row.system_order_no || '-')
      // const line6 = '入住确认号：' + (row.order_confirm_no || '-')
      const line7 =
        '订单金额：' +
        (row.total_rate !== null &&
        row.total_rate !== undefined &&
        row.total_rate !== ''
          ? '¥' + row.total_rate
          : '-')

      this.orderInfoText = [line1, line2, line3, line4, line5, line7].join('\n')
      this.dialogVisibleOrderInfo = true
    },
    copyOrderInfo() {
      if (!this.orderInfoText) return this.$message.warning('内容为空')
      const textarea = document.createElement('textarea')
      textarea.value = this.orderInfoText
      textarea.setAttribute('readonly', '')
      textarea.style.position = 'absolute'
      textarea.style.left = '-9999px'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(textarea)
    },
    handleShowNightPrices(row) {
      this.nightPricesData = row.night_prices || []
      this.nightPricesOrderId = row.order_id || ''
      this.nightPricesGuestName = row.link_man || ''
      this.dialogVisibleNightPrices = true
    },
    handleOrderDetail(row) {
      this.orderDetailId = row.order_id
      this.dialogVisibleOrderDetail = true
    },
    handleOrderDetailClosed() {
      this.orderDetailId = ''
    },
    handleOrderChangeLog(row) {
      this.$router.push({
        path: '/OrderChangeLog',
        query: { system_order_no: row.system_order_no, hideFilter: '1' },
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.box-card {
  text-align: center;

  .value {
    color: #546dfe;
    font-weight: bold;
    font-size: 26px;
  }

  .subtitle {
    font-size: 12px;
    color: gray;
    margin-top: 6px;
  }
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-bottom: 20px;
}

::v-deep .el-table .error-row {
  background-color: rgba(255, 0, 0, 0.2);
}

::v-deep .el-table .warning-row {
  background-color: rgba(255, 255, 0, 0.2);
}
</style>
